module.exports = __webpack_public_path__ + "static/media/mifacodi.d909ba00.jpg";